import React from "react";
import { connect } from "react-redux";
import { Actions as ACTIONS } from "../../store/actions/timesheetActions";
import { PlusIcon, WrenchScrewdriverIcon } from "@heroicons/react/20/solid";
import { Link } from "react-router-dom";
import ArchivedCompany from "../company-pages/ArchivedCompany";
import InvalidPermissions from "../company-pages/InvalidPermissions";
import IntegrationTimesheetImport from "../integrations/IntegrationTimesheetImport";
import TimesheetTable from "./TimesheetTable";

const ViewTimesheets = ({ timesheetSetOpenModal, settingsPermissions, userPermissions, archivedStatus }) => {
	if (archivedStatus == "Archived") return <ArchivedCompany />;
	if (userPermissions == "None") return <InvalidPermissions />;

	return (
		<>
			<div className="content bg-gray-lighter">
				<div className="row">
					<div className="col-sm-12">
						<div className="pull-left">
							<h1 className="page-heading">Timesheets</h1>
						</div>
						<div className="col-sm-4 pull-right">
							{settingsPermissions != "None" && (
								<Link
									className="btn btn-default pull-right"
									to="/organisation/settings/time-attendance"
									style={{ marginLeft: 10 }}
								>
									<WrenchScrewdriverIcon style={{ height: "1.5em", float: "left" }} />
								</Link>
							)}
							{userPermissions != "Read" && (
								<div
									className="btn btn-success pull-right"
									onClick={() => timesheetSetOpenModal(true, null, "timesheetPage")}
								>
									<PlusIcon style={{ height: "1.5em", float: "left", marginRight: 5 }} />
									<div style={{ float: "left" }}>Add Time Entry</div>
								</div>
							)}
						</div>
					</div>
				</div>
			</div>
			<div className="content mb-32">
				<IntegrationTimesheetImport />
				<div
					className="col-xs-12 pl-0"
					style={{ paddingBottom: "3rem", paddingTop: "3rem" }}
				>
					<div className="pull-left">
						<h5>Timesheets</h5>
					</div>
				</div>
			</div>
			<TimesheetTable location="timesheetPage" />
		</>
	);
};

const mapStateToProps = (state) => {
	const userPermissions = state?.permissions?.my?.permissions?.timesheets;
	const settingsPermissions = state?.permissions?.my?.permissions?.settings;

	return {
		settingsPermissions,
		userPermissions,
		archivedStatus: state?.company?.settings?.status,
	};
};

const mapDispatchToProps = (dispatch) => ({
	timesheetSetOpenModal: (status, timesheet, location) =>
		dispatch(ACTIONS.timesheetSetOpenModal(status, timesheet, location)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ViewTimesheets);
